export default function TrackInfoIcon({
  trackId,
  isPlaying,
  isActive,
  isLotterySegue = false,
  onInfoClick,
}) {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onInfoClick(e);
  };

  const icon = isPlaying ? "🎶" : isLotterySegue ? "🎰" : "i";
  const className = [
    "track-info-icon",
    isPlaying ? "playing" : "",
    isActive ? "active" : "",
    isLotterySegue ? "lottery" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={className} onClick={handleClick}>
      {icon}
    </span>
  );
}
